module.exports = __webpack_public_path__ + "img/title_wdhslx.f700d10c.png";